import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { AuthCard, Field, PrimaryButton, ErrorText } from "./_auth_ui";

export function SignUp() {
  const { signUp } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true); setError(null);
    try {
      await signUp(email, password);
      nav(`/verify?email=${encodeURIComponent(email)}`);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : "Sign up failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard title="Create your account" subtitle="Minimum 8 characters, one number, one uppercase.">
      <form onSubmit={onSubmit} className="space-y-4">
        <Field label="Email" type="email" value={email} onChange={setEmail} autoComplete="email" required />
        <Field label="Password" type="password" value={password} onChange={setPassword} autoComplete="new-password" required />
        <ErrorText error={error} />
        <PrimaryButton loading={loading}>Create account</PrimaryButton>
      </form>
      <p className="mt-4 text-xs text-neutral-500 text-center">
        By creating an account you agree to our{" "}
        <Link to="/terms" className="underline hover:text-black">Terms</Link>{" "}
        and{" "}
        <Link to="/privacy" className="underline hover:text-black">Privacy Policy</Link>.
      </p>
      <p className="mt-6 text-sm text-neutral-500 text-center">
        Already have one? <Link to="/signin" className="underline hover:text-black">Sign in</Link>
      </p>
    </AuthCard>
  );
}
